import logo from "./logo.svg";
import "./App.css";
import { useEffect, useState } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Header from "./Components/Header";
import Footer from "./Components/Footer";
import Casinopage from "./screens/CasinoPage/Casinopage";
import Transactionpage from "./screens/TransactionPage/Transactionpage";
import whitesun from "./images/whitesun.svg";
import moonwhite from "./images/moonwhite.svg";
import { Provider, useSelector } from "react-redux";
import { store } from "./store";
import GameTracker from "./screens/HomePage/Test";
import Test from "./screens/HomePage/Test";
import Accountpage from "./screens/AccountPage/AccountPage";
import ProtectedRoute from "./Components/ProtectedRoute";
import Betpage from "./screens/BetPage/BetPage";
import Casino from "./screens/CasinoPage/Casino";
import MatchProfile from "./screens/HomePage/components/MatchProfile";
import MatchProfilePage from "./screens/HomePage/MatchProfilePage";
import { ToastProvider } from "./screens/notificationPage/ToastContainer";
import { Toaster } from "react-hot-toast";
import { PublicRoute } from "./middlewares/AuthMiddleware";
import GamePage from "./screens/CasinoPage/GameModal";
import { selectUser } from "./store/auth-slice";
import { socketService } from "./store/socket";
import CenterLeague from "./screens/HomePage/Dashboard";
import { ThemeProvider, useTheme } from "./context/ThemeContext";
import AbxGameLoader from "./screens/CasinoPage/AbxGameLoader";
import ABXGameTester from "./screens/CasinoPage/AbxGameLoader";
import MobileCountriesPage from "./screens/HomePage/components/MobileCountries";
import HomeLayout from "./screens/HomePage/HomeLayout";

function App() {
  //   // Dark mode / Light mode state

  return (
    <Provider store={store}>
      <ThemeProvider>
        <Router>
          {/* <AbxGameLoader
            abxPlayFolder="https://api-provider-games.betskilla.com/assets"
            currency="USD"
            language="en"
            homeUrl="/"
            sessionToken="abcd1234"
            billingUuid="billing-xyz"
            gameId="abx_egypt_riddles"
            denominationList={[1, 10, 100]}
            betPerLine={[1, 5, 10]}
            denomination={1}
          /> */}
          <ToastProvider>
            {/* <Toaster position="top-center" reverseOrder={false}> */}
            <Routes>
              {/* <Route path="/about" element={<AboutPage />} /> */}
              {/* <Route path="/contact" element={<ContactPage />} /> */}
              <Route path="/test" element={<Test />} />
              <Route
                path="/profile"
                element={
                  <ProtectedRoute>
                    <Accountpage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/countries"
                element={
                  <HomeLayout>
                    <MobileCountriesPage />
                  </HomeLayout>
                }
              />
              <Route path="/header" element={<Header />} />
              <Route path="/abx" element={<ABXGameTester />} />
              <Route path="/footer" element={<Footer />} />
              <Route path="/sports" element={<CenterLeague />} />

              <Route
                path="/"
                element={
                  <PublicRoute>
                    <CenterLeague />
                  </PublicRoute>
                }
              />
              <Route path="/match/:id" element={<MatchProfilePage />} />
              <Route path="/casino" element={<Casinopage />} />
              {/* <Route path="/casino1" element={<Casino />} /> */}
              <Route
                path="/transaction"
                element={
                  <ProtectedRoute>
                    <Transactionpage />
                  </ProtectedRoute>
                }
              />
              <Route path="/game/:gameAlias" element={<GamePage />} />
              <Route
                path="/bet-history"
                element={
                  <ProtectedRoute>
                    <Betpage />
                  </ProtectedRoute>
                }
              />
            </Routes>
            {/* </Toaster> */}
          </ToastProvider>
        </Router>

        {/* <button
        onClick={toggleTheme}
        className="w-10 h-10 flex justify-center items-center bg-darkblue dark:bg-yellow rounded-[5px_0px_0px_5px] fixed right-0 z-10 top-[33%] sm:hidden"
      >
        <img
          src={isDarkMode ? moonwhite : whitesun}
          alt={"Light Mode"}
          className="size-5 s18:size-[26px]"
        />
      </button> */}
      </ThemeProvider>
    </Provider>
  );
}

export default App;
